import React from 'react';
import './PriceDifferenceInfo.css';
import { useNavigate } from 'react-router-dom';
import GlowingAdvanceIcon from '../../assets/GlowingAdvanceIcon.jsx';
import PropTypes from 'prop-types';
import PropTypeShapes from '../../services/Constants/PropTypeShapes.jsx';
import useNormalizedSubscriptionStatus from '../../services/utils/subscriptionUtils.js';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';

/**
 * @param {{ amount: number, isClubMember?: boolean }} root0 - component props
 * @param {number} root0.amount - savings amount to display (from clubPriceDifference in API response)
 * @param {boolean} [root0.isClubMember] - whether the user is a VodaPay Club member
 * @returns {JSX.Element|null} PriceDifferenceInfo component
 */
export default function PriceDifferenceInfo({ amount = 0, isClubMember: isClubMemberProp }) {
  const navigateTo = useNavigate();
  const diffAmount = amount || 0;
  const subscriptionStatus = useNormalizedSubscriptionStatus();
  const isClubMember = isClubMemberProp ?? (subscriptionStatus === 'active');

  if (!diffAmount) return null;

  return (
    <div className='price-difference-info-container'>
      <div className='price-difference-info-left-content'>
        {
          isClubMember ? (
            <>
              You got <span className='price-difference-info-amount'>R{diffAmount}</span> extra for being a VodaPay Club member
            </>
          ) : (
            <>
              You lost <span className='price-difference-info-amount'>R{diffAmount}</span> extra – Join the club for more value
            </>
          )
        }
      </div>
      <div
        className={ isClubMember ? 'price-difference-info-right-icon' : 'price-difference-info-right-button' }
        onClick={
          () => {
            if (!isClubMember) {
              navigateTo(ROUTES.VODAPAY_CLUB, { replace: false });
            }
          }
        }
      >
        {isClubMember ? <GlowingAdvanceIcon /> : 'Try for R0.00'}
      </div>
    </div>
  );
}

PriceDifferenceInfo.propTypes = {
  amount: PropTypeShapes.amount,
  isClubMember: PropTypes.bool,
};
